import React, { useEffect, useState } from "react";
import { ApiService } from "../../api";
import { Space, Spin } from "antd";
import { useNavigate } from "react-router-dom";

type Props = {
  formId?: number;
  requestId?: number;
};

type Request = {
  id: number;
  request_number: string;
};

const LinkedObjectViewComponent = ({ formId, requestId }: Props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [requests, setRequests] = useState<Request[]>([]);

  useEffect(() => {
    (async () => {
      setLoading(true);

      getFormValues(requestId, formId);

      setLoading(false);
    })();
  }, [formId, requestId]);

  const getFormValues = async (requestId?: number, form_id?: number) => {
    if (!requestId) return undefined;
    const result = await ApiService.apiMainRequestFormRetrieve(
      form_id!,
      requestId!
    );
    setRequests(result);
  };

  return (
    <Spin spinning={loading}>
      {requests.map((x) => (
        <p>
          <Space size="middle">
            <a onClick={() => navigate(`/requests/${x.id}`)}>
              {x.request_number}
            </a>
          </Space>
        </p>
      ))}
    </Spin>
  );
};

export default LinkedObjectViewComponent;
